import { useCallback } from 'react';
import { atom, useAtom } from 'jotai';
import { EmployerUserContact } from '@restworld/utility-types';

export type CollaboratorActionModalVariantType = 'default' | 'noHeading';
export const collaboratorActionModalVariantAtom = atom<CollaboratorActionModalVariantType>('default');
collaboratorActionModalVariantAtom.debugLabel = 'collaboratorActionModalVariantAtom';

export const isCollaboratorActionModalOpenAtom = atom(false);
isCollaboratorActionModalOpenAtom.debugLabel = 'showCollaboratorActionModalAtom';

export const useCollaboratorActionModal = () => {
  const [isCollaboratorActionModalOpen, setIsCollaboratorActionModalOpen] = useAtom(isCollaboratorActionModalOpenAtom);

  const closeCollaboratorActionModal = useCallback(
    () => setIsCollaboratorActionModalOpen(false),
    [setIsCollaboratorActionModalOpen]
  );
  const openCollaboratorActionModal = useCallback(
    () => setIsCollaboratorActionModalOpen(true),
    [setIsCollaboratorActionModalOpen]
  );

  return {
    isCollaboratorActionModalOpen,
    openCollaboratorActionModal,
    closeCollaboratorActionModal,
  };
};

export const collaboratorActionAtom = atom<'create' | 'update' | 'delete'>('create');
collaboratorActionAtom.debugLabel = 'collaboratorActionAtom';

export const selectedCollaboratorAtom = atom<EmployerUserContact | null>({} as EmployerUserContact);
selectedCollaboratorAtom.debugLabel = 'selectedCollaboratorAtom';

export const collaboratorWelcomeModalOpenAtom = atom(false);
collaboratorWelcomeModalOpenAtom.debugLabel = 'collaboratorWelcomeModalOpenAtom';

export function useCollaboratorWelcomeModal() {
  const [isOpen, setIsOpen] = useAtom(collaboratorWelcomeModalOpenAtom);

  const openModal = useCallback(() => {
    setIsOpen(true);
  }, [setIsOpen]);

  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  return { isOpen, openModal, closeModal };
}
